import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  tieuDe: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  chuyenMuc: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required)
});
